const pagesIndividualRequestTasksEn = {
  columns: {
    progress: 'Progress',
    requestType: 'Request Type',
    status: 'Status',
    submittedAt: 'Request Date'
  },
  empty: 'No requests',
  pageTitle: 'My Requests',
  tabs: {
    all: 'All',
    approved: 'Approved',
    notSubmitted: 'Not Submitted',
    pendingApproval: 'Pending Approval',
    rejected: 'Rejected',
    returned: 'Returned'
  }
};
export default pagesIndividualRequestTasksEn;